BaseLayer = require './base-layer'
ContainerMixin = require 'mixins/map-container'
toLatLng = require 'computeds/to-lat-lng'

module.exports = App.LeafletMapComponent = BaseLayer.extend ContainerMixin,
  tagName: 'div'
  leafletOptions: [
    'center'
    'zoom'
    'minZoom'
    'maxZoom'
    'maxBounds'
    'crs'
    'dragging'
    'touchZoom'
    'scrollWheelZoom'
    'doubleClickZoom'
    'boxZoom'
    'tap'
    'tapTolerance'
    'trackResize'
    'worldCopyJump'
    'closePopupOnClick'
    'bounceAtZoomLimits'
    'keyboard'
    'keyboardPanOffset'
    'keyboardZoomOffset'
    'inertia'
    'inertiaDeceleration'
    'inertiaMaxSpeed'
    'inertiaThreshold'
    'zoomControl'
    'attributionControl'
    'fadeAnimation'
    'zoomAnimation'
    'zoomAnimationThreshold'
    'markerZoomAnimation'
  ]
  leafletEvents: [
    'click'
    'dblclick'
    'mousedown'
    'mouseup'
    'mouseover'
    'mouseout'
    'mousemove'
    'contextmenu'
    'focus'
    'blur'
    'preclick'
    'load'
    'unload'
    'viewreset'
    'movestart'
    'move'
    'moveend'
    'dragstart'
    'drag'
    'dragend'
    'zoomstart'
    'zoomend'
    'zoomlevelschange'
    'resize'
    'autopanstart'
    'layeradd'
    'layerremove'
    'baselayerchange'
    'overlayadd'
    'overlayremove'
    'locationfound'
    'locationerror'
    'popupopen'
    'popupclose'
  ]
  leafletProperties: [
    'zoom:setZoom'
    'center:panTo'
    'maxBounds:setMaxBounds'
    'bounds:fitBounds'
  ]
  center: toLatLng()
  containerLayer: null
  didInsertElement: ->
    @_super.apply this, arguments
    @layerSetup()
    @get('_childLayers').invoke 'layerSetup'
    return
  willDestroyElement: ->
    @_super.apply this, arguments
    @get('_childLayers').invoke 'layerTeardown'
    @get('_childLayers').clear()
    @layerTeardown()
    return
  registerWithParent: ->
  unregisterWithParent: ->
  createLayer: ->
    options = @get('options')
    # Don't set center and zoom right now.
    # Let base layer bind the events first
    delete options.center
    delete options.zoom
    @L.map @element, options
  didCreateLayer: ->
    #after base layer bound the events, we can now set the map's view
    Ember.assert 'You must provide either valid `bounds` or a `center` (or `lat`/`lng`) and a `zoom` value.', @get('bounds') and !@get('center') and !@get('zoom') or !@get('bounds') and @get('center') and @get('zoom')
    if @get('bounds')
      @_layer.fitBounds @get('bounds'), reset: true
    else
      @_layer.setView @get('center'), @get('zoom'), reset: true
    return
